import { render } from "./repeatingEvent.vue?vue&type=template&id=dd545fec&scoped=true"
import script from "./repeatingEvent.vue?vue&type=script&lang=js"
export * from "./repeatingEvent.vue?vue&type=script&lang=js"

import "./repeatingEvent.vue?vue&type=style&index=0&id=dd545fec&scoped=true&lang=scss"

import exportComponent from "/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dd545fec"]])

export default __exports__